module.exports = __webpack_public_path__ + "static/media/logo.166e9a10.png";